(function () {
  'use strict';

  function initMarquee(root) {
    if (!root || root.dataset.marqueeReady === 'true') return;

    const track = root.querySelector('[data-marquee-track]');
    if (!track) return;

    const viewport = root.querySelector('.marquee__viewport') || track.parentElement || root;

    root.dataset.marqueeReady = 'true';
    root.classList.add('marquee--js');

    let speed = parseFloat(root.dataset.speed);
    if (!speed || speed <= 0) speed = 22;

    let offset = 0;
    let oneSetWidth = 0;
    let pxPerMs = 0;
    let lastTime = null;
    let rafId = null;

    function getTrackGap() {
      const cs = window.getComputedStyle(track);
      const gap = parseFloat(cs.columnGap || cs.gap || '0');
      return isNaN(gap) ? 0 : gap;
    }

    function ensureFilled() {
      const firstGroup = track.querySelector('[data-marquee-group]');
      if (!firstGroup) return;

      const viewportWidth = viewport.clientWidth || root.clientWidth || 0;
      const groupWidth = firstGroup.getBoundingClientRect().width;
      if (groupWidth <= 0) return;

      let safety = 0;
      while (track.scrollWidth < viewportWidth + groupWidth + 1 && safety < 30) {
        const clone = firstGroup.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
        safety++;
      }
    }

    function measure() {
      ensureFilled();

      const firstGroup = track.querySelector('[data-marquee-group]');
      if (!firstGroup) return;

      oneSetWidth = firstGroup.getBoundingClientRect().width + getTrackGap();
      pxPerMs = oneSetWidth > 0 ? oneSetWidth / (speed * 1000) : 0;
      if (oneSetWidth > 0) {
        offset = offset % oneSetWidth;
      }
    }

    function step(now) {
      if (lastTime === null) lastTime = now;
      let dt = now - lastTime;
      lastTime = now;

      if (dt > 100) dt = 16;

      if (pxPerMs > 0) {
        offset += pxPerMs * dt;
        if (offset >= oneSetWidth) offset -= oneSetWidth;
        track.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';
      }

      rafId = window.requestAnimationFrame(step);
    }

    function start() {
      if (rafId !== null) return;
      lastTime = null;
      rafId = window.requestAnimationFrame(step);
    }

    function stop() {
      if (rafId === null) return;
      window.cancelAnimationFrame(rafId);
      rafId = null;
    }

    measure();
    start();

    const images = track.querySelectorAll('img');
    images.forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', measure, { once: true });
        img.addEventListener('error', measure, { once: true });
      }
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure).catch(function () {});
    }

    let resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(measure, 150);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });
  }

  function initAll(scope) {
    const container = scope || document;
    const marquees = container.querySelectorAll('[data-marquee]');
    marquees.forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
